import { Validator } from 'vee-validate'

function bsn11proofCheck (value) {
  if (!value) {
    return false
  }

  var sum = value
  .split('') // make it an array
  .map(v => v / 1) // force all numeric values
  .reverse() // reverse, because 11 proof check requires multiplication by reversed index (e.g. first value needs to be multiplied by <length of full string>)
  .reduce((current, numericValue, index) => {
    var multiplyBy = (index === 0)
    ? -1 // bsn 11 proof requires the ending numeric value to be multiplied by -1 instead of index+1 (please note that we reversed order earlier)
    : (index + 1)

    return current + (numericValue * multiplyBy) // return sum
  }, 0)

  return sum % 11 === 0 // 11 check
}

Validator.extend('bsn11proof', {
  validate: bsn11proofCheck,
  messages: {
    nl: field => field + ' is niet correct'
  }
})

export default {
  required: true,
  min: 9,
  max: 9,
  numeric: true,
  bsn11proof: true
}
